let Index = () => import('../pages/helpdesk/Index');
let HelpLayout = () => import('../components/helpdesk/HelpdeskLayout');
let BoardList = () => import('../pages/helpdesk/BoardList');
let BoardView = () => import('../pages/helpdesk/BoardView');
let CustomPage = () => import('../pages/CustomPage');

export default [
    {
        path: '/helpdesk/',
        component: HelpLayout,
        redirect: '/helpdesk/index',
        children: [
            {
                path: 'index',
                component: Index,
                name: 'index',
                meta: { requiresAuth: false },
            },
            {
                path: 'board/:boardCode',
                component: BoardList,
                name: 'BoardList',
                meta: { requiresAuth: false },
            },
            {
                path: 'board/list/category/:categorySlug?',
                component: BoardList,
                name: 'BoardFilter',
                meta: { requiresAuth: false },
            },
            {
                path: 'board/search/:searchKeyword?',
                component: BoardList,
                name: 'SearchBoardList',
                meta: { requiresAuth: false },
            },
            {
                path: 'board/view/:slug',
                component: BoardView,
                name: 'BoardView',
                meta: { requiresAuth: false },
            },
            {
                path: ':pageSlug?',
                component: CustomPage,
                name: 'HelpdeskPage',
                meta: { requiresAuth: false },
            },
        ],
    },
];
